export default __webpack_public_path__ + "static/media/Asset Banner 1@3x.ac701e6f.svg";